export function showAuthDialog (state, value) {
  state.showAuthDialog = value
}

export function panoramaHeader (state, value) {
  state.panoramaHeader = value
}
